'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:upgrader'), {
  error: debug('libp2p:upgrader:err')
});

var errCode = require('err-code'); // @ts-ignore multistream-select does not export types


var Multistream = require('multistream-select');

var _require = require('libp2p-interfaces/src/connection'),
    Connection = _require.Connection;

var PeerId = require('peer-id');

var _require2 = require('it-pipe'),
    pipe = _require2.pipe; // @ts-ignore mutable-proxy does not export types


var mutableProxy = require('mutable-proxy');

var _require3 = require('./errors'),
    codes = _require3.codes;
/**
 * @typedef {import('libp2p-interfaces/src/transport/types').MultiaddrConnection} MultiaddrConnection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxerFactory} MuxerFactory
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').Muxer} Muxer
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('libp2p-interfaces/src/crypto/types').Crypto} Crypto
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */

/**
 * @typedef CryptoResult
 * @property {MultiaddrConnection} conn A duplex iterable
 * @property {PeerId} remotePeer
 * @property {string} protocol
 */


var Upgrader = /*#__PURE__*/function () {
  /**
   * @param {object} options
   * @param {PeerId} options.localPeer
   * @param {import('./metrics')} [options.metrics]
   * @param {Map<string, Crypto>} [options.cryptos]
   * @param {Map<string, MuxerFactory>} [options.muxers]
   * @param {(connection: Connection) => void} options.onConnection - Called when a connection is upgraded
   * @param {(connection: Connection) => void} options.onConnectionEnd
   */
  function Upgrader(_ref) {
    var localPeer = _ref.localPeer,
        metrics = _ref.metrics,
        _ref$cryptos = _ref.cryptos,
        cryptos = _ref$cryptos === void 0 ? new Map() : _ref$cryptos,
        _ref$muxers = _ref.muxers,
        muxers = _ref$muxers === void 0 ? new Map() : _ref$muxers,
        _ref$onConnectionEnd = _ref.onConnectionEnd,
        onConnectionEnd = _ref$onConnectionEnd === void 0 ? function () {} : _ref$onConnectionEnd,
        _ref$onConnection = _ref.onConnection,
        onConnection = _ref$onConnection === void 0 ? function () {} : _ref$onConnection;

    _classCallCheck(this, Upgrader);

    this.localPeer = localPeer;
    this.metrics = metrics;
    this.cryptos = cryptos;
    this.muxers = muxers;
    /** @type {import("./pnet") | null} */

    this.protector = null;
    this.protocols = new Map();
    this.onConnection = onConnection;
    this.onConnectionEnd = onConnectionEnd;
  }
  /**
   * Upgrades an inbound connection
   *
   * @async
   * @param {MultiaddrConnection} maConn
   * @returns {Promise<Connection>}
   */


  _createClass(Upgrader, [{
    key: "upgradeInbound",
    value: function () {
      var _upgradeInbound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(maConn) {
        var encryptedConn, remotePeer, upgradedConn, Muxer, cryptoProtocol, setPeer, proxyPeer, _mutableProxy, idString, protectedConn, _yield$this$_encryptI, _yield$this$_multiple;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.metrics) {
                  _mutableProxy = mutableProxy();
                  setPeer = _mutableProxy.setTarget;
                  proxyPeer = _mutableProxy.proxy;
                  idString = (Math.random() * 1e9).toString(36) + Date.now();
                  setPeer({
                    toB58String: function toB58String() {
                      return idString;
                    }
                  });
                  maConn = this.metrics.trackStream({
                    stream: maConn,
                    remotePeer: proxyPeer
                  });
                }

                log('Starting the inbound connection upgrade'); // Protect

                protectedConn = maConn;

                if (!this.protector) {
                  _context.next = 7;
                  break;
                }

                _context.next = 6;
                return this.protector.protect(maConn);

              case 6:
                protectedConn = _context.sent;

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return this._encryptInbound(this.localPeer, protectedConn, this.cryptos);

              case 10:
                _yield$this$_encryptI = _context.sent;
                encryptedConn = _yield$this$_encryptI.conn;
                remotePeer = _yield$this$_encryptI.remotePeer;
                cryptoProtocol = _yield$this$_encryptI.protocol;

                if (!this.muxers.size) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return this._multiplexInbound(encryptedConn, this.muxers);

              case 17:
                _yield$this$_multiple = _context.sent;
                upgradedConn = _yield$this$_multiple.stream;
                Muxer = _yield$this$_multiple.Muxer;
                _context.next = 23;
                break;

              case 22:
                upgradedConn = encryptedConn;

              case 23:
                _context.next = 31;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](7);
                log.error('Failed to upgrade inbound connection', _context.t0);
                _context.next = 30;
                return maConn.close(_context.t0);

              case 30:
                throw _context.t0;

              case 31:
                if (this.metrics) {
                  this.metrics.updatePlaceholder(proxyPeer, remotePeer);
                  setPeer(remotePeer);
                }

                log('Successfully upgraded inbound connection');
                return _context.abrupt("return", this._createConnection({
                  cryptoProtocol: cryptoProtocol,
                  direction: 'inbound',
                  maConn: maConn,
                  upgradedConn: upgradedConn,
                  Muxer: Muxer,
                  remotePeer: remotePeer
                }));

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 25]]);
      }));

      function upgradeInbound(_x) {
        return _upgradeInbound.apply(this, arguments);
      }

      return upgradeInbound;
    }()
    /**
     * Upgrades an outbound connection
     *
     * @async
     * @param {MultiaddrConnection} maConn
     * @returns {Promise<Connection>}
     */

  }, {
    key: "upgradeOutbound",
    value: function () {
      var _upgradeOutbound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(maConn) {
        var idStr, remotePeerId, encryptedConn, remotePeer, upgradedConn, cryptoProtocol, Muxer, setPeer, proxyPeer, _mutableProxy2, idString, protectedConn, _yield$this$_encryptO, _yield$this$_multiple2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idStr = maConn.remoteAddr.getPeerId();

                if (idStr) {
                  _context2.next = 3;
                  break;
                }

                throw errCode(new Error('outbound connection must have a peer id'), codes.ERR_INVALID_MULTIADDR);

              case 3:
                remotePeerId = PeerId.createFromB58String(idStr);

                if (this.metrics) {
                  _mutableProxy2 = mutableProxy();
                  setPeer = _mutableProxy2.setTarget;
                  proxyPeer = _mutableProxy2.proxy;
                  idString = (Math.random() * 1e9).toString(36) + Date.now();
                  setPeer({
                    toB58String: function toB58String() {
                      return idString;
                    }
                  });
                  maConn = this.metrics.trackStream({
                    stream: maConn,
                    remotePeer: proxyPeer
                  });
                }

                log('Starting the outbound connection upgrade'); // Protect

                protectedConn = maConn;

                if (!this.protector) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 10;
                return this.protector.protect(maConn);

              case 10:
                protectedConn = _context2.sent;

              case 11:
                _context2.prev = 11;
                _context2.next = 14;
                return this._encryptOutbound(this.localPeer, protectedConn, remotePeerId, this.cryptos);

              case 14:
                _yield$this$_encryptO = _context2.sent;
                encryptedConn = _yield$this$_encryptO.conn;
                remotePeer = _yield$this$_encryptO.remotePeer;
                cryptoProtocol = _yield$this$_encryptO.protocol;

                if (!this.muxers.size) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return this._multiplexOutbound(encryptedConn, this.muxers);

              case 21:
                _yield$this$_multiple2 = _context2.sent;
                upgradedConn = _yield$this$_multiple2.stream;
                Muxer = _yield$this$_multiple2.Muxer;
                _context2.next = 27;
                break;

              case 26:
                upgradedConn = encryptedConn;

              case 27:
                _context2.next = 35;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2["catch"](11);
                log.error('Failed to upgrade outbound connection', _context2.t0);
                _context2.next = 34;
                return maConn.close(_context2.t0);

              case 34:
                throw _context2.t0;

              case 35:
                if (this.metrics) {
                  this.metrics.updatePlaceholder(proxyPeer, remotePeer);
                  setPeer(remotePeer);
                }

                log('Successfully upgraded outbound connection');
                return _context2.abrupt("return", this._createConnection({
                  cryptoProtocol: cryptoProtocol,
                  direction: 'outbound',
                  maConn: maConn,
                  upgradedConn: upgradedConn,
                  Muxer: Muxer,
                  remotePeer: remotePeer
                }));

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 29]]);
      }));

      function upgradeOutbound(_x2) {
        return _upgradeOutbound.apply(this, arguments);
      }

      return upgradeOutbound;
    }()
    /**
     * A convenience method for generating a new `Connection`
     *
     * @private
     * @param {object} options
     * @param {string} options.cryptoProtocol - The crypto protocol that was negotiated
     * @param {'inbound' | 'outbound'} options.direction - One of ['inbound', 'outbound']
     * @param {MultiaddrConnection} options.maConn - The transport layer connection
     * @param {MuxedStream | MultiaddrConnection} options.upgradedConn - A duplex connection returned from multiplexer and/or crypto selection
     * @param {MuxerFactory} [options.Muxer] - The muxer to be used for muxing
     * @param {PeerId} options.remotePeer - The peer the connection is with
     * @returns {Connection}
     */

  }, {
    key: "_createConnection",
    value: function _createConnection(_ref2) {
      var _this = this;

      var cryptoProtocol = _ref2.cryptoProtocol,
          direction = _ref2.direction,
          maConn = _ref2.maConn,
          upgradedConn = _ref2.upgradedConn,
          Muxer = _ref2.Muxer,
          remotePeer = _ref2.remotePeer;

      /** @type {import("libp2p-interfaces/src/stream-muxer/types").Muxer} */
      var muxer;
      /** @type {import("libp2p-interfaces/src/connection/connection").CreatedMuxedStream | undefined} */

      var newStream;
      /** @type {Connection} */

      var connection; // eslint-disable-line prefer-const

      if (Muxer) {
        // Create the muxer
        muxer = new Muxer({
          // Run anytime a remote stream is created
          onStream: function () {
            var _onStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(muxedStream) {
              var mss, _yield$mss$handle, stream, protocol;

              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (connection) {
                        _context3.next = 2;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 2:
                      mss = new Multistream.Listener(muxedStream);
                      _context3.prev = 3;
                      _context3.next = 6;
                      return mss.handle(Array.from(_this.protocols.keys()));

                    case 6:
                      _yield$mss$handle = _context3.sent;
                      stream = _yield$mss$handle.stream;
                      protocol = _yield$mss$handle.protocol;
                      log('%s: incoming stream opened on %s', direction, protocol);
                      if (_this.metrics) _this.metrics.trackStream({
                        stream: stream,
                        remotePeer: remotePeer,
                        protocol: protocol
                      });
                      connection.addStream(muxedStream, {
                        protocol: protocol
                      });

                      _this._onStream({
                        connection: connection,
                        stream: _objectSpread(_objectSpread({}, muxedStream), stream),
                        protocol: protocol
                      });

                      _context3.next = 18;
                      break;

                    case 15:
                      _context3.prev = 15;
                      _context3.t0 = _context3["catch"](3);
                      log.error(_context3.t0);

                    case 18:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[3, 15]]);
            }));

            function onStream(_x3) {
              return _onStream2.apply(this, arguments);
            }

            return onStream;
          }(),
          // Run anytime a stream closes
          onStreamEnd: function onStreamEnd(muxedStream) {
            connection.removeStream(muxedStream.id);
          }
        });

        newStream = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(protocols) {
            var muxedStream, mss, _yield$mss$select, stream, protocol;

            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    log('%s: starting new stream on %s', direction, protocols);
                    muxedStream = muxer.newStream();
                    mss = new Multistream.Dialer(muxedStream);
                    _context4.prev = 3;
                    _context4.next = 6;
                    return mss.select(protocols);

                  case 6:
                    _yield$mss$select = _context4.sent;
                    stream = _yield$mss$select.stream;
                    protocol = _yield$mss$select.protocol;
                    if (_this.metrics) _this.metrics.trackStream({
                      stream: stream,
                      remotePeer: remotePeer,
                      protocol: protocol
                    });
                    return _context4.abrupt("return", {
                      stream: _objectSpread(_objectSpread({}, muxedStream), stream),
                      protocol: protocol
                    });

                  case 13:
                    _context4.prev = 13;
                    _context4.t0 = _context4["catch"](3);
                    log.error('could not create new stream', _context4.t0);
                    throw errCode(_context4.t0, codes.ERR_UNSUPPORTED_PROTOCOL);

                  case 17:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[3, 13]]);
          }));

          return function newStream(_x4) {
            return _ref3.apply(this, arguments);
          };
        }(); // Pipe all data through the muxer


        pipe(upgradedConn, muxer, upgradedConn).catch(log.error);
      }

      var _timeline = maConn.timeline;
      maConn.timeline = new Proxy(_timeline, {
        set: function set() {
          if (connection && (arguments.length <= 1 ? undefined : arguments[1]) === 'close' && (arguments.length <= 2 ? undefined : arguments[2]) && !_timeline.close) {
            // Wait for close to finish before notifying of the closure
            _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;

                      if (!(connection.stat.status === 'open')) {
                        _context5.next = 4;
                        break;
                      }

                      _context5.next = 4;
                      return connection.close();

                    case 4:
                      _context5.next = 9;
                      break;

                    case 6:
                      _context5.prev = 6;
                      _context5.t0 = _context5["catch"](0);
                      log.error(_context5.t0);

                    case 9:
                      _context5.prev = 9;

                      _this.onConnectionEnd(connection);

                      return _context5.finish(9);

                    case 12:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[0, 6, 9, 12]]);
            }))();
          }

          return Reflect.set.apply(Reflect, arguments);
        }
      });
      maConn.timeline.upgraded = Date.now();

      var errConnectionNotMultiplexed = function errConnectionNotMultiplexed() {
        throw errCode(new Error('connection is not multiplexed'), 'ERR_CONNECTION_NOT_MULTIPLEXED');
      }; // Create the connection


      connection = new Connection({
        localAddr: maConn.localAddr,
        remoteAddr: maConn.remoteAddr,
        localPeer: this.localPeer,
        remotePeer: remotePeer,
        stat: {
          direction: direction,
          // @ts-ignore
          timeline: maConn.timeline,
          multiplexer: Muxer && Muxer.multicodec,
          encryption: cryptoProtocol
        },
        newStream: newStream || errConnectionNotMultiplexed,
        getStreams: function getStreams() {
          return muxer ? muxer.streams : errConnectionNotMultiplexed();
        },
        close: function () {
          var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return maConn.close();

                  case 2:
                    // Ensure remaining streams are aborted
                    if (muxer) {
                      muxer.streams.map(function (stream) {
                        return stream.abort();
                      });
                    }

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          function close() {
            return _close.apply(this, arguments);
          }

          return close;
        }()
      });
      this.onConnection(connection);
      return connection;
    }
    /**
     * Routes incoming streams to the correct handler
     *
     * @private
     * @param {object} options
     * @param {Connection} options.connection - The connection the stream belongs to
     * @param {MuxedStream} options.stream
     * @param {string} options.protocol
     */

  }, {
    key: "_onStream",
    value: function _onStream(_ref5) {
      var connection = _ref5.connection,
          stream = _ref5.stream,
          protocol = _ref5.protocol;
      var handler = this.protocols.get(protocol);
      handler({
        connection: connection,
        stream: stream,
        protocol: protocol
      });
    }
    /**
     * Attempts to encrypt the incoming `connection` with the provided `cryptos`.
     *
     * @private
     * @async
     * @param {PeerId} localPeer - The initiators PeerId
     * @param {*} connection
     * @param {Map<string, Crypto>} cryptos
     * @returns {Promise<CryptoResult>} An encrypted connection, remote peer `PeerId` and the protocol of the `Crypto` used
     */

  }, {
    key: "_encryptInbound",
    value: function () {
      var _encryptInbound2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(localPeer, connection, cryptos) {
        var mss, protocols, _yield$mss$handle2, stream, protocol, crypto;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                mss = new Multistream.Listener(connection);
                protocols = Array.from(cryptos.keys());
                log('handling inbound crypto protocol selection', protocols);
                _context7.prev = 3;
                _context7.next = 6;
                return mss.handle(protocols);

              case 6:
                _yield$mss$handle2 = _context7.sent;
                stream = _yield$mss$handle2.stream;
                protocol = _yield$mss$handle2.protocol;
                crypto = cryptos.get(protocol);
                log('encrypting inbound connection...');

                if (crypto) {
                  _context7.next = 13;
                  break;
                }

                throw new Error("no crypto module found for ".concat(protocol));

              case 13:
                _context7.t0 = _objectSpread;
                _context7.t1 = _objectSpread;
                _context7.t2 = {};
                _context7.next = 18;
                return crypto.secureInbound(localPeer, stream);

              case 18:
                _context7.t3 = _context7.sent;
                _context7.t4 = (0, _context7.t1)(_context7.t2, _context7.t3);
                _context7.t5 = {};
                _context7.t6 = {
                  protocol: protocol
                };
                return _context7.abrupt("return", (0, _context7.t0)(_context7.t4, _context7.t5, _context7.t6));

              case 25:
                _context7.prev = 25;
                _context7.t7 = _context7["catch"](3);
                throw errCode(_context7.t7, codes.ERR_ENCRYPTION_FAILED);

              case 28:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[3, 25]]);
      }));

      function _encryptInbound(_x5, _x6, _x7) {
        return _encryptInbound2.apply(this, arguments);
      }

      return _encryptInbound;
    }()
    /**
     * Attempts to encrypt the given `connection` with the provided `cryptos`.
     * The first `Crypto` module to succeed will be used
     *
     * @private
     * @async
     * @param {PeerId} localPeer - The initiators PeerId
     * @param {MultiaddrConnection} connection
     * @param {PeerId} remotePeerId
     * @param {Map<string, Crypto>} cryptos
     * @returns {Promise<CryptoResult>} An encrypted connection, remote peer `PeerId` and the protocol of the `Crypto` used
     */

  }, {
    key: "_encryptOutbound",
    value: function () {
      var _encryptOutbound2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(localPeer, connection, remotePeerId, cryptos) {
        var mss, protocols, _yield$mss$select2, stream, protocol, crypto;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                mss = new Multistream.Dialer(connection);
                protocols = Array.from(cryptos.keys());
                log('selecting outbound crypto protocol', protocols);
                _context8.prev = 3;
                _context8.next = 6;
                return mss.select(protocols);

              case 6:
                _yield$mss$select2 = _context8.sent;
                stream = _yield$mss$select2.stream;
                protocol = _yield$mss$select2.protocol;
                crypto = cryptos.get(protocol);
                log('encrypting outbound connection to %j', remotePeerId);

                if (crypto) {
                  _context8.next = 13;
                  break;
                }

                throw new Error("no crypto module found for ".concat(protocol));

              case 13:
                _context8.t0 = _objectSpread;
                _context8.t1 = _objectSpread;
                _context8.t2 = {};
                _context8.next = 18;
                return crypto.secureOutbound(localPeer, stream, remotePeerId);

              case 18:
                _context8.t3 = _context8.sent;
                _context8.t4 = (0, _context8.t1)(_context8.t2, _context8.t3);
                _context8.t5 = {};
                _context8.t6 = {
                  protocol: protocol
                };
                return _context8.abrupt("return", (0, _context8.t0)(_context8.t4, _context8.t5, _context8.t6));

              case 25:
                _context8.prev = 25;
                _context8.t7 = _context8["catch"](3);
                throw errCode(_context8.t7, codes.ERR_ENCRYPTION_FAILED);

              case 28:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[3, 25]]);
      }));

      function _encryptOutbound(_x8, _x9, _x10, _x11) {
        return _encryptOutbound2.apply(this, arguments);
      }

      return _encryptOutbound;
    }()
    /**
     * Selects one of the given muxers via multistream-select. That
     * muxer will be used for all future streams on the connection.
     *
     * @private
     * @async
     * @param {MultiaddrConnection} connection - A basic duplex connection to multiplex
     * @param {Map<string, MuxerFactory>} muxers - The muxers to attempt multiplexing with
     * @returns {Promise<{ stream: MuxedStream, Muxer?: MuxerFactory}>} A muxed connection
     */

  }, {
    key: "_multiplexOutbound",
    value: function () {
      var _multiplexOutbound2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(connection, muxers) {
        var dialer, protocols, _yield$dialer$select, stream, protocol, Muxer;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dialer = new Multistream.Dialer(connection);
                protocols = Array.from(muxers.keys());
                log('outbound selecting muxer %s', protocols);
                _context9.prev = 3;
                _context9.next = 6;
                return dialer.select(protocols);

              case 6:
                _yield$dialer$select = _context9.sent;
                stream = _yield$dialer$select.stream;
                protocol = _yield$dialer$select.protocol;
                log('%s selected as muxer protocol', protocol);
                Muxer = muxers.get(protocol);
                return _context9.abrupt("return", {
                  stream: stream,
                  Muxer: Muxer
                });

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9["catch"](3);
                throw errCode(_context9.t0, codes.ERR_MUXER_UNAVAILABLE);

              case 17:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[3, 14]]);
      }));

      function _multiplexOutbound(_x12, _x13) {
        return _multiplexOutbound2.apply(this, arguments);
      }

      return _multiplexOutbound;
    }()
    /**
     * Registers support for one of the given muxers via multistream-select. The
     * selected muxer will be used for all future streams on the connection.
     *
     * @private
     * @async
     * @param {MultiaddrConnection} connection - A basic duplex connection to multiplex
     * @param {Map<string, MuxerFactory>} muxers - The muxers to attempt multiplexing with
     * @returns {Promise<{ stream: MuxedStream, Muxer?: MuxerFactory}>} A muxed connection
     */

  }, {
    key: "_multiplexInbound",
    value: function () {
      var _multiplexInbound2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(connection, muxers) {
        var listener, protocols, _yield$listener$handl, stream, protocol, Muxer;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                listener = new Multistream.Listener(connection);
                protocols = Array.from(muxers.keys());
                log('inbound handling muxers %s', protocols);
                _context10.prev = 3;
                _context10.next = 6;
                return listener.handle(protocols);

              case 6:
                _yield$listener$handl = _context10.sent;
                stream = _yield$listener$handl.stream;
                protocol = _yield$listener$handl.protocol;
                Muxer = muxers.get(protocol);
                return _context10.abrupt("return", {
                  stream: stream,
                  Muxer: Muxer
                });

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10["catch"](3);
                throw errCode(_context10.t0, codes.ERR_MUXER_UNAVAILABLE);

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[3, 13]]);
      }));

      function _multiplexInbound(_x14, _x15) {
        return _multiplexInbound2.apply(this, arguments);
      }

      return _multiplexInbound;
    }()
  }]);

  return Upgrader;
}();

module.exports = Upgrader;